import axios from 'axios'
import * as config from './config'
import Cookies from 'js-cookie';

axios.defaults.baseURL = config.HOST;

/**
 *
 */
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers['cid'] = Cookies.get('cid')
  config.headers['uid'] = Cookies.get('uid')
  config.headers['token'] = Cookies.get('token')
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

/**
 * 响应拦截器
 */
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么

  //
  if(response.headers['file-name']){
    return response
  }else if(response.data.code >=100 && response.data.code < 200){
    window.vue.$router.replace({name:'login-home'})
  }else{
    return response.data
  }
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
})

function exportExcel(res) {
  let data = res.data;
  let fileName = decodeURI(res.headers['file-name'])
  if (data && !data.byteLength) {
    alert('表格数据为空，无法导出！');
    return;
  }
  try {
    let linkElement = document.createElement('a');
    let blob = new Blob([data], {
      type: 'application/octet-stream'
    });
    let url = window.URL.createObjectURL(blob);
    // console.log(url)
    linkElement.setAttribute('href', url);
    linkElement.setAttribute("download", fileName);
    let clickEvent = new MouseEvent("click", {
      "view": window,
      "bubbles": true,
      "cancelable": false
    });
    linkElement.dispatchEvent(clickEvent);
  } catch (ex) {
    console.log(ex);
  }
}

export default axios



// WEBPACK FOOTER //
// ./src/common/request.js